<div class="tile mb-0">
  <h5>
    {{ 'statistics.dividends.headline' | transloco }}
  </h5>
  @if (dividends?.length) {
    <div class="row">
      <div class="col-12">
        <div class="nav nav-tabs mt-1">
          <ng-template #nav let-dividendType="dividendType">
            <div class="nav-item">
              <a
                [attr.data-zid]="'dividend-type-tab-' + dividendType"
                class="nav-link cursor-pointer font-medium"
                (click)="changeType(dividendType)"
                [class.active]="activeDividendType === dividendType"
              >
                {{ 'statistics.dividends.tabs.' + dividendType | transloco }}
              </a>
            </div>
          </ng-template>
          <ng-container [ngTemplateOutlet]="nav" [ngTemplateOutletContext]="{ dividendType: DividendType.Forecast }" />
          <ng-container [ngTemplateOutlet]="nav" [ngTemplateOutletContext]="{ dividendType: DividendType.Historical }" />
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 mb-2">
        {{ 'statistics.dividends.' + activeDividendType + '.text' | transloco }}
      </div>
      <div class="col-12 auto-overflow">
        @if (!labels?.length) {
          {{ 'statistics.dividends.empty' | transloco }}
        }
        <div
          class="chart-container"
          [class.active]="labels?.length"
          [ngClass]="{
            s: labels?.length >= 4,
            m: labels?.length >= 8,
            l: labels?.length >= 12,
          }"
        >
          <canvas id="dividends" baseChart [data]="data | async" [options]="options" [plugins]="plugins" type="bar"></canvas>
        </div>
      </div>
    </div>
    @if (labels?.length) {
      @if (total) {
        <div class="row mt-2">
          <div class="col-12">{{ 'statistics.dividends.total' | transloco }} {{ total | currency }}</div>
        </div>
      }
      <div class="row mt-2 hidden-xs hidden-sm">
        <div class="col-12">
          <a
            data-zid="dividends-details-toggle"
            class="link-secondary cursor-pointer no-select"
            (click)="shouldDisplayDetails = !shouldDisplayDetails"
          >
            {{ (!shouldDisplayDetails ? 'statistics.dividends.link.inactive' : 'statistics.dividends.link.active') | transloco }}
            <span
              data-zid="details-arrow"
              class="sorter-after-flat"
              [ngClass]="{ 'sorter-after-flat--down': !shouldDisplayDetails, 'sorter-after-flat--active': shouldDisplayDetails }"
            ></span>
          </a>
        </div>
      </div>
    }
    @if (shouldDisplayDetails) {
      <div class="row mt-4 hidden-xs hidden-sm" data-zid="dividends-details">
        <div class="col-12">
          @for (dividend of dividends | filterEmptyDividend: activeDividendType; track dividend.isin) {
            <div class="dividend-instrument-row d-flex justify-content-around">
              @for (label of labels; track label.period; let i = $index) {
                <div class="dividend-value-container">
                  @if (i === 0) {
                    <web-components-instrument-details-link class="instrument-name font-medium" [isin]="dividend.isin">
                      {{ dividend.instrumentName }}
                    </web-components-instrument-details-link>
                  }
                  <div class="dividend-value text-center" [ngClass]="activeDividendType">
                    {{ dividend | dividendByPeriod: label.period : activeDividendType }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <div class="col-12 mt-2">
          {{ 'statistics.dividends.details.hint' | transloco }}
        </div>
        <div class="col-12 mt-2 text-size-large">
          {{ 'statistics.dividends.details.star-hint' | transloco }}
        </div>
      </div>
    }
  } @else {
    <div class="row mt-4">
      <div class="col-12" data-zid="empty-dividends-message">
        {{ 'statistics.dividends.empty' | transloco }}
      </div>
    </div>
  }
</div>
